import { Flex, Text } from '@chakra-ui/react';
import { FaKeyboard } from '@react-icons/all-files/fa/FaKeyboard';
import { FaLink } from '@react-icons/all-files/fa/FaLink';
import { useState } from 'react';

import Title from '../../components/Title';
import Button from '../../components/ui/buttons/Button';
import { copyToClipboard } from '../../utils/copy';

const InAppBrowserPrompt = ({ onContinue }: { onContinue: () => void }) => {
  const [copied, setCopied] = useState(false);

  const copyLink = async () => setCopied(await copyToClipboard(window.location.href));

  return (
    <Flex direction="column" flex={1} w="full">
      <Flex direction="column" flex={1} justify="center" px={7} textAlign="left">
        <Text fontSize="44px" mb={4}>
          🎙️
        </Text>
        <Title fontSize="27px" lineHeight={1.2} textAlign="left" letterSpacing="-0.3px">
          This works best in your browser
        </Title>
        <Text mt={3} fontSize="16px" lineHeight={1.6} color="leaseEndGray" fontWeight={500}>
          The browser built into this app can't record audio reliably. Open this link in Safari or
          Chrome to answer out loud, or continue here and type your answers instead.
        </Text>
      </Flex>
      <Flex direction="column" gap={2.5} px={5} pb={7}>
        <Button w="full" textTransform="uppercase" leftIcon={<FaLink />} onClick={copyLink}>
          {copied ? 'Link copied!' : 'Copy link for my browser'}
        </Button>
        <Button w="full" variant="secondary" leftIcon={<FaKeyboard />} onClick={onContinue}>
          Continue and type instead
        </Button>
      </Flex>
    </Flex>
  );
};

export default InAppBrowserPrompt;
